import { PropsWithChildren } from 'react';
import CountryProvider from 'providers/CountryProvider';
import { useGetPortalSettingsQuery } from 'slices';

const SettingsCountryProvider = ({ children }: PropsWithChildren<{}>) => {
  const { currentData: settings } = useGetPortalSettingsQuery();

  return (
    <CountryProvider value={settings?.branding.countries}>
      {children}
    </CountryProvider>
  );
};

export default SettingsCountryProvider;
